$(function(){

    $('.js-course-details, .js-course-details-back').on('click', function(){

        //open modal & close the current active courses details
        const dataID = $(this).data('id');
        $('.active-courses').toggle();
        $('.course-details[data-id="'+ dataID +'"]').toggleClass('hide');
        $(window).trigger('resize');
        $('.slider-init-thumbnails').slick('setPosition');
        $('.slider-init-thumbnails-nav').slick('setPosition');
    });

    $('.js-ac-details, .js-acs-details, .js-ac-back').on('click', function(){
        $('.slider-init-custom').slick('refresh');
        //open modal & close the current active courses details
        const dataID = $(this).data('id');
        $('.js-active-courses-trainer').toggle();
        $('.active-courses__details[data-id="'+ dataID +'"]').toggleClass('hide');
        $('.js-ac-students-list[data-id="'+ dataID +'"]').toggleClass('hide');
    });


    setTimeout(function(){
        $('.js-ac-courses, .js-ac-attendee').addClass('hide');
    }, 400);

});